/**
 * @example See input and output below
 * Input:
 * const address = {
 *   name: 'Address 1',
 *   address: {
 *     street: {name: 'Test Street', no: 123}
 *   }
 * };
 * Output:
 * {
 *   'address.street.name': 'Test Street'
 *   'address.street.no': 123
 *   'name': 'Address 1'
 * }
 */
export function toFlatPropertyMap<T extends Record<string, any>>(ob: T) {
  const toReturn = {} as T;
  for (const i in ob) {
    if (!Object.prototype.hasOwnProperty.call(ob, i)) continue;
    if (typeof ob[i] == 'object' && ob[i] !== null) {
      const flatObject = toFlatPropertyMap(ob[i]);
      for (const x in flatObject) {
        if (!Object.prototype.hasOwnProperty.call(flatObject, x)) continue;
        // @ts-expect-error -- Yes, string can be used to index type T
        toReturn[i + '.' + x] = flatObject[x];
      }
    } else {
      toReturn[i] = ob[i];
    }
  }
  return toReturn;
}